import type { FilterObject, Locale, Sort } from "@agapi/mlc-core";

export const DEFAULT_LIMIT = 24;

export const getDefaultFacets = (locale: Locale): Record<string, FilterObject> => {
  return {
    categories: { type: 'distinct', values: [] },
    brand_name: { type: 'distinct', values: [] },
    [`price_amount_${locale.country}`]: { type: 'range' },
  };
};

const getSortFromSearchParams = (url: URL, locale: Locale): Sort[] => {
  const [type, order] = (url.searchParams.get('sort')?.trim().split('_') ?? []) as [Exclude<Sort['type'], 'attribute'>, Sort['order']]
  if (type) {
    if (type.startsWith('price') && order) {
      return [{ type: 'attribute', attributeName: `price_amount_${locale.country}`, order }];
    }
    return [{ type, order: 'asc' }]
  }
  return [];
}

export const getFacetsFromSearchParams = (url: URL, locale: Locale): Record<string, FilterObject> => {
  const searchParams = new URLSearchParams(url.search);
  const brands = searchParams.get('brands')?.trim()?.split(',') ?? [];
  const categories = searchParams.get('categories')?.trim()?.split(',') ?? [];
  const priceMax = searchParams.get('price-max')?.trim();
  const priceMin = searchParams.get('price-min')?.trim();
  const price = {
    ...(priceMax && /\d+/.test(priceMax) ? { max: +priceMax } : {}),
    ...(priceMin && /\d+/.test(priceMin) ? { min: +priceMin } : {}),
  }

  const filterFacets: Record<string, FilterObject> = {
    categories: { type: 'distinct', values: categories },
    brand_name: { type: 'distinct', values: brands },
    [`price_amount_${locale.country}`]: { type: 'range', values: price },
  };

  return filterFacets;
};

// Server side only (move to collections.server.ts)
export const getFacetsAndSort = (url: URL, locale: Locale): {
  filterFacets: Record<string, FilterObject>,
  sortBy?: Sort[]
} => {
  return {
    filterFacets: Object.assign(getDefaultFacets(locale), getFacetsFromSearchParams(url, locale)),
    sortBy: getSortFromSearchParams(url, locale)
  };
}
